import { render, staticRenderFns } from "./IconSectionColumn.vue?vue&type=template&id=9ac98876&"
import script from "./IconSectionColumn.vue?vue&type=script&lang=js&"
export * from "./IconSectionColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ac98876')) {
      api.createRecord('9ac98876', component.options)
    } else {
      api.reload('9ac98876', component.options)
    }
    module.hot.accept("./IconSectionColumn.vue?vue&type=template&id=9ac98876&", function () {
      api.rerender('9ac98876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSectionColumn.vue"
export default component.exports